<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <v-flex lg12>
        <v-card>
          <hpo-filter :headers="headers" :viewName="viewName" v-on:applyFilter="applyFilter" v-on:quickFilter="quickFilter"></hpo-filter>
          <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="pagination"
            :server-items-length="total_rows"
            :footer-props="items_per_page"
            :must-sort="true"
            :loading="loading"
            :mobile-breakpoint="100"
          >
            <template v-slot:item="{ item }">
              <tr :active="item.selected" @click="item.selected = !item.selected" class="list-clickable">
                <td>{{ item.ID }}</td>
                <td>{{ item.Email }}</td>
                <td>{{ item.FullName}}</td>
                <td>{{ item.PhoneNumber }}</td>
                <td v-bind:style="{ 'color': get_status_color(item.Status, customer_status)}">{{ item.Status | display_value(customer_status) }}</td>
                <!-- <td class="text-end">{{ item.Point | currency }}</td>
                <td class="text-end">{{ item.LevelName }}</td> -->
                <td class="text-center">
                  <a 
                  :href="'/khach-hang/' + item.ID"
                  ><i role="button" medium="" class="v-icon notranslate mr-2 v-icon--link material-icons theme--light">{{roleEditable ? 'edit' : 'visibility'}}</i></a>
                  <v-icon v-if="roleEditable" medium @click="deleteItem(item.ID)">delete</v-icon>
                </td>
              </tr>
            </template>
            <template slot="no-data">
              <span>
                <p class="pt-2">Không có dữ liệu</p>
              </span>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import configs from "../../configs";
import Filtering from "@/components/Filtering";
import { sendErrorNotice } from "@/commons/utils";
import _ from "lodash";

export default {
  components: {
    "hpo-filter": Filtering
  },
  data() {
    let dataType = configs.DATA_TYPE;
    return {
      search: "",
      headers: [
        {
          text: "ID",
          value: "ID",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tài khoản",
          value: "Email",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Tên",
          value: "FullName",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Điện thoại",
          value: "PhoneNumber",
          filterable: true,
          dataType: dataType["String"]
        },
        {
          text: "Trạng thái",
          value: "Status",
          filterable: true,
          dataType: dataType["Enum"],
          values: configs.CUSTOMER_STATUS_LIST
        },
        // {
        //   text: "Tích lũy",
        //   value: "Point",
        //   filterable: true,
        //   dataType: dataType["Number"]
        // },
        // {
        //   text: "Hạng",
        //   value: "LevelName",
        //   filterable: true,
        //   dataType: dataType["String"]
        // },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      customer_status: configs.CUSTOMER_STATUS_LIST,
      pagination: _.cloneDeep(configs.PAGINATION),
      items_per_page: _.cloneDeep(configs.ITEMS_PER_PAGE),
      viewName: "customer_list",
      filterConditions: [],
      quickFilterConditions: []
    };
  },
  computed: {
    ...mapState({
      items: state => state.customer.all.data,
      total_rows: state => state.customer.all.total,
      loading: state => state.customer.loading,
      selected: state => state.customer.selected
    }),
    roleEditable() {
      return this.$store.state.authentication.user.roleid == configs.ROLE_TYPE.Admin;
    }
  },
  watch: {
    pagination: {
      handler: function(val, oldVal) {
        let filterConditions = this.$store.state.commons.filterConditions;
        this.filterConditions = !_.isEmpty(filterConditions) ? filterConditions[this.viewName] : []
        this.filter_data();
      },
      deep: true
    },
    roleEditable() {
      this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.roleEditable});
    }
  },
  methods: {
    filter_data: function() {
      var param = {
        pagination: this.pagination,
        search_term: this.search,
        filter: this.filterConditions,
        quickFilter: this.quickFilterConditions
      };
      this.$store.dispatch("customer/getCustomerList", param);
    },
    gotoDetail: function(id) {
      this.$router.push({
        name: "CustomerDetail",
        params: {
          Pid: id,
          title: `Khách hàng (#${id})`
        }
      });
    },
    get_status_color(val, enums) {
      return this.$options.filters.display_color(val, enums);
    },
    applyFilter(filterConditions) {
      let sortBy = this.pagination.sortBy
      let sortDesc = this.pagination.sortDesc
      this.pagination = configs.PAGINATION;
      this.pagination.sortBy = sortBy;
      this.pagination.sortDesc = sortDesc;
      this.filterConditions = filterConditions;
      this.filter_data();
    },
    quickFilter(filterConditions) {
      this.quickFilterConditions = filterConditions;
      this.filter_data();
    },
    createData() {
      if(this.roleEditable) {
        this.$store.commit("customer/setCustomerDetail", {
        'data': {
            ID: 0,
            RoleID: 0,
            Status: 1,
            Username: '',
            FullName: '',
            PhoneNumber: '',
            FeeWeight: 0,
            FeeVolume: 0,
            is_active: 1,
            is_admin: 0
        }
        });
        this.$router.push({
          name: "CustomerDetail",
          params: {
            Pid: 'tao-moi',
            title: `Tạo mới khách hàng`
          }
        });
      }
      else {
        sendErrorNotice("Bạn không có quyền tạo mới khách hàng!");
      }
    },
    getStaffName(staffId) {
      const staff = _.find(this.staffs, {
        ID: staffId
      });
      return staff ? staff.FullName : "";
    },
    saveStaff(id, csId) {
      const updateInfo = {
        ID: id,
        CustomerServiceID: csId
      };
      this.$store.dispatch("customer/setCustomerDetail", {
        'data': updateInfo,
        'id': updateInfo.ID
      });
    },
    deleteItem: function(id) {
      window.getApp.$emit('REQUEST_DELETE_DATA', id);
    }
  },
  mounted() {
    this.$root.$emit('REQUEST_ROOT_OPTION', {invisibleCreateButton: !this.roleEditable});
    this.$root.$on("REQUEST_CREATE_DATA", this.createData);
    this.$root.$on("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$on("CONFIRMED_REMOVE_DATA", (id) => {
      this.$store.dispatch("customer/removeCustomerDetail", id);
      setTimeout(this.filter_data, 200);
    });
  },
  beforeMount() {
    this.$store.commit("customer/setCustomerList", {data: []})
  },
  beforeDestroy() {
    this.$root.$off("REQUEST_CREATE_DATA", this.createData);
    this.$root.$off("REQUEST_REFRESH_DATA", this.filter_data);
    this.$root.$off("CONFIRMED_REMOVE_DATA");
  }
};
</script>
<style scoped>
a {
    text-decoration: none !important;
}
</style>